export enum Permission {
  CREATE_SESSION = 'create:session',
  READ_SESSION = 'read:session',
  UPDATE_SESSION = 'update:session',
  DELETE_SESSION = 'delete:session',
  CREATE_ATTENDANT = 'create:attendant',
  READ_ATTENDANT = 'read:attendant',
  UPDATE_ATTENDANT = 'update:attendant',
  DELETE_ATTENDANT = 'delete:attendant',
  CREATE_CONNECTION = 'create:connection',
  READ_CONNECTION = 'read:connection',
  UPDATE_CONNECTION = 'update:connection',
  DELETE_CONNECTION = 'delete:connection',
  CREATE_CONTACT = 'create:contact',
  READ_CONTACT = 'read:contact',
  UPDATE_CONTACT = 'update:contact',
  DELETE_CONTACT = 'delete:contact',
  CREATE_DEPARTMENT = 'create:department',
  READ_DEPARTMENT = 'read:department',
  UPDATE_DEPARTMENT = 'update:department',
  DELETE_DEPARTMENT = 'delete:department',
  CREATE_FLOW = 'create:flow',
  READ_FLOW = 'read:flow',
  UPDATE_FLOW = 'update:flow',
  DELETE_FLOW = 'delete:flow',
  CREATE_TAG = 'create:tag',
  READ_TAG = 'read:tag',
  UPDATE_TAG = 'update:tag',
  DELETE_TAG = 'delete:tag',
  CREATE_TEAM = 'create:team',
  READ_TEAM = 'read:team',
  UPDATE_TEAM = 'update:team',
  DELETE_TEAM = 'delete:team',
  CREATE_TRANSMISSION = 'create:transmission',
  READ_TRANSMISSION = 'read:transmission',
  UPDATE_TRANSMISSION = 'update:transmission',
  DELETE_TRANSMISSION = 'delete:transmission',
  UPDATE_USER = 'update:user',
  CREATE_AGENT = 'create:agent',
  READ_AGENT = 'read:agent',
  UPDATE_AGENT = 'update:agent',
  DELETE_AGENT = 'delete:agent',
  CREATE_INTEGRATION = 'create:integration',
  READ_INTEGRATION = 'read:integration',
  UPDATE_INTEGRATION = 'update:integration',
  DELETE_INTEGRATION = 'delete:integration',
}

export const DEFAULT_ATTENDANT_PERMISSIONS: Permission[] = [
  Permission.READ_SESSION,
  Permission.READ_CONTACT,
]

export enum SidebarModule {
  DASHBOARD = 'dashboard',
  CHAT = 'chat',
  ATTENDANTS = 'attendants',
  DEPARTMENTS = 'departments',
  AI_AGENTS = 'ai_agents',
  AUTOMATIONS = 'automations',
  FLOWS = 'flows',
  INTEGRATIONS = 'integrations',
  SETTINGS = 'settings',
}

export const SIDEBAR_MODULE_PERMISSIONS: Record<
  SidebarModule,
  Permission[]
> = {
  [SidebarModule.DASHBOARD]: [],
  [SidebarModule.CHAT]: [Permission.READ_SESSION],
  [SidebarModule.ATTENDANTS]: [Permission.READ_ATTENDANT],
  [SidebarModule.DEPARTMENTS]: [Permission.READ_DEPARTMENT],
  [SidebarModule.AI_AGENTS]: [Permission.READ_AGENT],
  [SidebarModule.AUTOMATIONS]: [Permission.READ_TRANSMISSION],
  [SidebarModule.FLOWS]: [Permission.READ_FLOW],
  [SidebarModule.INTEGRATIONS]: [Permission.READ_INTEGRATION],
  [SidebarModule.SETTINGS]: [],
}

export const SIDEBAR_MODULE_LABELS: Record<SidebarModule, string> = {
  [SidebarModule.DASHBOARD]: 'Dashboard',
  [SidebarModule.CHAT]: 'Conversas / Chat ao vivo',
  [SidebarModule.ATTENDANTS]: 'Atendentes',
  [SidebarModule.DEPARTMENTS]: 'Departamentos',
  [SidebarModule.AI_AGENTS]: 'Agentes de IA',
  [SidebarModule.AUTOMATIONS]: 'Automações',
  [SidebarModule.FLOWS]: 'Fluxos',
  [SidebarModule.INTEGRATIONS]: 'Integrações',
  [SidebarModule.SETTINGS]: 'Configurações',
}
